import { StorageKey } from 'types/storage/storage-key.enum';
import { TUserAuthStatus } from 'types/user/user-auth-status.type';

export const setAuthStatusToLocalStorage = (authStatus: TUserAuthStatus): void => 
    localStorage.setItem(StorageKey.AuthStatus, authStatus);

